export const mdiMenuDown = 'm7 10 5 5 5-5z';